(function() {
  if (window.__etCollectionSlidersInit) return;
  window.__etCollectionSlidersInit = true;

  function initAllSliders() {
    document.querySelectorAll('[data-swiper]').forEach(function(swiperEl) {
      if (swiperEl.swiper) return;
      var id = swiperEl.getAttribute('data-swiper');
      new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        pagination: {
          el: '[data-pagination="' + id + '"]',
          clickable: true
        },
        navigation: {
          nextEl: '[data-next="' + id + '"]',
          prevEl: '[data-prev="' + id + '"]'
        }
      });
    });
  }

  function waitAndInit() {
    if (typeof Swiper !== 'undefined') {
      initAllSliders();
    } else {
      setTimeout(waitAndInit, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitAndInit);
  } else {
    waitAndInit();
  }

  document.addEventListener('facet:update', function() {
    var checkInterval = setInterval(function() {
      var section = document.querySelector('.shopify-section--main-collection');
      if (section && !section.classList.contains('is-loading')) {
        clearInterval(checkInterval);
        setTimeout(function() {
          if (typeof Swiper !== 'undefined') initAllSliders();
          initMaterialDragScroll();
        }, 100);
      }
    }, 100);
  });

  function syncMaterialToSidebar() {
    var mainForm = document.querySelector('#facet-form[update-on-change]') || document.querySelector('#facet-form');
    if (!mainForm) return;

    mainForm.querySelectorAll('input[name="filter.p.m.custom.maat"]').forEach(function(el) {
      el.remove();
    });

    document.querySelectorAll('[data-material-filter]').forEach(function(cb) {
      if (cb.checked) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = cb.name;
        hidden.value = cb.value;
        hidden.setAttribute('data-synced-material', '');
        mainForm.appendChild(hidden);
      }
    });
  }

  document.addEventListener('change', function(e) {
    if (e.target.hasAttribute('data-material-filter')) {
      syncMaterialToSidebar();
      var mainForm = document.querySelector('#facet-form[update-on-change]') || document.querySelector('#facet-form');
      if (!mainForm) return;

      mainForm.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  function initMaterialDragScroll() {
    var slider = document.querySelector('.coll-main__top-filter-list');
    if (!slider || slider.__etDragInit) return;
    slider.__etDragInit = true;

    var isDown = false;
    var startX;
    var scrollLeft;

    slider.addEventListener('mousedown', function(e) {
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', function() {
      isDown = false;
      slider.classList.remove('scroll-active');
    });

    slider.addEventListener('mouseup', function() {
      isDown = false;
      slider.classList.remove('scroll-active');
    });

    slider.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - slider.offsetLeft;
      var walk = (x - startX) * 2;
      if (Math.abs(walk) > 5) {
        slider.classList.add('scroll-active');
        slider.scrollLeft = scrollLeft - walk;
      }
    });
  }

  document.addEventListener('listbox:change', function(e) {
    var sortByEl = document.querySelector('facet-sort-by');
    if (!sortByEl) return;
    if (sortByEl.contains(e.target)) return;

    var section = e.target.closest('.shopify-section') || sortByEl.closest('.shopify-section');
    if (!section) return;
    var sectionId = section.id.replace('shopify-section-', '');
    var url = new URL(location.href);
    url.searchParams.set('sort_by', e.detail.value);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.delete('page');
    sortByEl.dispatchEvent(new CustomEvent('facet:update', {
      bubbles: true,
      detail: { url: url }
    }));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMaterialDragScroll);
  } else {
    initMaterialDragScroll();
  }
})();
